import Icon from '../../../components/AppIcon';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    platform: [
      { label: 'عن دوائر', labelEn: 'About Dawaaer', path: '/about-dawaaer' },
      { label: 'من نحن؟', labelEn: 'How We Work', path: '/about' },
      { label: 'الدوائر العشر', labelEn: 'Ten Circles', path: '/circles' },
      { label: 'الفريق', labelEn: 'Team', path: '/team' }]

  };

  const socialLinks = [
    { icon: 'X', label: 'X', url: 'https://x.com/Dawaer_Hub' },
    { icon: 'Facebook', label: 'فيسبوك', url: 'https://www.facebook.com/dawaer.hub/' },
    { icon: 'Instagram', label: 'انستغرام', url: 'https://www.instagram.com/dawaer.hub/' },
    { icon: 'Linkedin', label: 'لينكد إن', url: 'https://www.linkedin.com/company/dawaaer' }];


  return (
    <footer className="w-full bg-[var(--color-card)] border-t border-[var(--color-border)] mt-12 md:mt-16 lg:mt-20 h-auto">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-3">
        <div className="flex flex-col lg:flex-row justify-between gap-y-8 gap-x-6 mt-[-32px] md:mt-[-48px] py-6">
          {/* Right: Branding */}
          <div className="space-y-2 md:space-y-3 max-w-sm">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center bg-gradient-to-br from-[var(--color-primary)] to-[var(--color-accent)] relative">
                <Icon name="Circle" size={18} color="white" />
                <div className="absolute inset-0 rounded-full border-2 border-[var(--color-primary)] animate-ping opacity-20" />
              </div>
              <span className="text-xl md:text-2xl font-bold text-[var(--color-primary)]" style={{ fontFamily: 'El Messiri, serif' }}>
                دوائر
              </span>
            </div>
            <p className="text-xs md:text-sm text-[var(--color-muted-foreground)] leading-relaxed">
              نحاول تقديم منتج ثقافيّ عربيّ يليق بموروثنا الهائل
            </p>
          </div>

          {/* Left: Contact & Social Icons */}
          <div className="flex flex-col lg:items-end text-right lg:text-left">
            <h3 className="text-sm md:text-base font-bold text-[var(--color-foreground)] mb-2 md:mb-3">
              تواصل معنا
            </h3>
            <p className="text-base text-[var(--color-muted-foreground)] mb-3 md:mb-4">
              Info@dawaaer.com
            </p>
            <div className="flex items-center gap-2 mt-auto">
              {socialLinks?.map((social) =>
                <a
                  key={social?.label}
                  href={social?.url}
                  className="w-8 h-8 md:w-9 md:h-9 rounded-full bg-[var(--color-background)] hover:bg-[var(--color-accent)] transition-colors flex items-center justify-center group"
                  aria-label={social?.label}>

                  <Icon
                    name={social?.icon}
                    size={16}
                    color="var(--color-foreground)"
                    className="group-hover:text-[var(--color-accent-foreground)]" />

                </a>
              )}
            </div>
          </div>
        </div>

        <div className="pt-2 border-t border-[var(--color-border)] mt-3">
          <div className="flex items-center justify-center">
            <p className="md:text-sm text-[var(--color-muted-foreground)] text-center text-xs pt-1.5">
              © {currentYear} <span className="font-bold text-[var(--color-foreground)]">دوائر</span>. جميع حقوق النشر محفوظة لأصحابها.
            </p>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;